/**
 * PostgREST caps every response at max_rows = 1000 WITHOUT an error: a list read in one
 * request silently stops at 1000 rows (see ENGINEERING.md, « Le piège max_rows »). Readers
 * that need the whole table page through it here. Keep the query ordered on a stable key.
 */
export const MAX_ROWS = 1000;

type PageResult<T> = PromiseLike<{ data: T[] | null; error: { message: string } | null }>;

export async function fetchAllPages<T>(
  page: (from: number, to: number) => PageResult<T>,
  pageSize = MAX_ROWS,
): Promise<T[]> {
  const rows: T[] = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await page(from, from + pageSize - 1);
    if (error) throw new Error(error.message);
    const batch = data ?? [];
    rows.push(...batch);
    if (batch.length < pageSize) return rows;
  }
}
